import { locationAddApi } from "../../api/location/locationAddApi"

type PayloadShape = Parameters<typeof locationAddApi>[0]

export async function locationAddService(payload: PayloadShape, token: string) {
	return await locationAddApi(payload, token)
}
